/*
 * @Author: CYX
 * @Date: 2020-07-09 17:45:13
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-09 17:46:24
 */ 
export const serviceListCn = {
    hengyemingc: "行业名称：",
    fuwulb: "服务类目：",
    diquorguojia: "地区/国家：",
    chukozhichi: "出口中东地区产品检测认证服务，由 RACS&TAM 独家提供服务支持。",
    pingjia: "评价",
    xiaoliang: "销量",
    jiage: "价格",
    zixuncs: "咨询次数",
}


// WEBPACK FOOTER //
// ./src/lang/home/serviceList/serviceListCn.js